<template>
  <router-link
    v-if="data"
    :to="{
      name: 'product',
      params: { id: data.id, link: data.link },
    }"
    class="product-search"
  >
    <ImgComponent :head_img="data | item_img" width="70" height="80" class="product-search__image" />
    <div class="product-search__content">
      <span :title="data.title" class="product-search__title">
        {{ data.title }}
      </span>
      <span v-if="data.price" class="product-search__prices">
        <span class="product-search__price">
          {{ data.price | share_price(data) | formatPrice }}
        </span>
        <span v-if="data.join_share && data.join_share.share" class="product-search__old-price">
          {{ data.price | formatPrice }}
        </span>
      </span>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "ProductCardSearchVersionComponent",
  props: {
    data: Object,
  },
};
</script>

<style lang="stylus">
@import "~@/styles/mixins/maxlines.styl"
.product-search {
  display flex
  gap 16px
  min-height 55px

  &:hover &__title {
    color: var(--link);
  }

  &__image {
    width 45px
    height 55px
    object-fit cover
    object-position center
    border-radius var(--small_radius)
    flex-shrink 0
  }

  &__content {
    display: flex;
    flex-direction column
    grid-gap: 4px;
  }

  &__title {
    font-weight: normal;
    font-size: 0.875em;
    line-height: 24px;
    color: var(--body-color);
    maxlines(2)
    min-height 48px
    flex-shrink 0
  }

  &__prices {
    display flex
    align-items center
    gap 12px
  }

  &__price {
    font-weight: 600;
    font-size: 1.125em;
    line-height: 24px;
    color: var(--gray-900);
  }

  &__old-price {
    font-weight: normal;
    font-size: 0.875em;
    line-height: 18px;
    text-decoration-line: line-through;
    color: var(--gray-300);
  }
}
</style>
